export default __webpack_public_path__ + "static/media/exit-outline.4aa7f44a.svg";